// extracted by mini-css-extract-plugin
export var stepActive = "_1w-3";
export var stepCompleted = "_1w-4";
export var stepConnectorLine = "_1w-b";
export var stepIndicatorCircle = "_1w-6";
export var stepIndicatorCircleCompleted = "_1w-7";
export var stepIndicatorCircleDefault = "_1w-8";
export var stepIndicatorTextCompleted = "_1w-9";
export var stepIndicatorTextDefault = "_1w-a";
export var stepPending = "_1w-5";
export var wizardContainer = "_1w-1";
export var wizardContent = "_1w-2";
export var wizardModal = "_1w-0";